import React, { useEffect, useRef, useState } from "react";
import RetroButton from "../../retro/button/retro-button.component";
import RetroInput from "../../retro/input/input.component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EmojiPicker from "../../emoji/emojiPicker";
import FloatingPanel from "../../overlays/FloatingPanel";
import "./step1.styles.scss";
import "../../title-actions/title-actions.scss";

export default function Step1({ stationName, setStationName, setSteps, setStartDate, setEndDate, startDate, endDate, setEmoji, emoji }) {
  const [duration, setDuration] = useState(30);
  const [emojiOpen, setEmojiOpen] = useState(false);
  const anchor = useRef(null);
  const nameOK = !!stationName?.trim() && !["Enter Station name", "Enter Project name"].includes(stationName.trim());
  useEffect(() => {
    if (!startDate) return;
    const end = new Date(startDate);
    end.setDate(end.getDate() + duration);
    setEndDate(end);
  }, [startDate, duration, setEndDate]);
  return <section className="sectionName">
    <h2>Create Project</h2>
    <div className="st__emojicon-name-row">
      <div className="st__emojiconwithlabel">
        <button ref={anchor} type="button" className="st__emoji-trigger" aria-label="Choose project icon" onClick={() => setEmojiOpen(true)}>{emoji.native}</button>
        <label>Icon</label>
      </div>
      <div className="sn__name" onChange={event => setStationName(event.target.value)}><RetroInput placeholder={stationName} autoFocus /></div>
    </div>
    {emojiOpen && <FloatingPanel modal anchorRef={anchor} width={360} label="Choose project icon" onClose={() => setEmojiOpen(false)} className="ant-title-editor">
      <button type="button" className="ant-title-editor__hide-picker" onClick={() => setEmojiOpen(false)}>Close</button>
      <EmojiPicker embedded autoFocus={false} onEmojiSelect={value => { setEmoji(value); setEmojiOpen(false); }} />
    </FloatingPanel>}
    <div className="cr__duration-label"><label>duration</label></div>
    <div className="cr__duration-buttons">
      {[[3,"3 days"],[5,"5 days"],[7,"1 week"],[14,"2 weeks"],[30,"1 month"],[90,"3 months"],[180,"6 months"]].map(([days,label]) =>
        <button key={days} type="button" aria-pressed={duration === days} onClick={() => setDuration(days)}>{label}</button>)}
    </div>
    <div className="cr__twocolumnsnarrow">
      <div><label>start date</label><DatePicker popperProps={{ strategy: "fixed" }} wrapperClassName="datepicker"
        placeholderText="Select a start date" dateFormat="MMMM d, yyyy" selected={startDate}
        onChange={date => { if (date) setStartDate(date); }} todayButton="today" /></div>
      <div><label>end date</label><DatePicker placeholderText="Select end or deadline" dateFormat="MMMM d, yyyy"
        selected={endDate} onChange={setEndDate} /></div>
    </div>
    <div className="sn__next"><RetroButton onClick={() => {
      if (!nameOK) { alert("Project name is required"); return; }
      setStationName(stationName.trim()); setSteps({ step1: false, step2: true });
    }} style={{ opacity: nameOK ? 1 : .5 }}>Next</RetroButton></div>
  </section>;
}
